//#region src/random/uuid.ts
function e() {
	return crypto.randomUUID();
}
//#endregion
export { e as uuid };

//# sourceMappingURL=uuid.js.map